import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import MediaQuery from 'react-responsive';
import { Link } from 'react-router-dom';

const screenWidth = window.screen.width;

class StockInsiderTrading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            symbol: this.props.symbol,
            limit: this.props.limit
        };
    }

    componentDidMount() {
        console.log('screenWidth', screenWidth);
        ApiService.getInsiderTrading(this.state.symbol)
            .then(result => {
                console.log('Insider Trading', result);
                let filteredData = [];
                let newFilteredData = [];
                let length = this.state.limit === undefined ? 1000 : this.state.limit;
                let tmpLength = 1000;
                if (result.length > 0) {
                    tmpLength = result.length < tmpLength ? result.length : tmpLength;
                    for (var i = 0; i < tmpLength; i++) {
                        if (result[i].transactionType === 'S-Sale' || result[i].transactionType === 'P-Purchase') {
                            filteredData.push(result[i]);
                        }
                    }
                    length = filteredData.length < length ? filteredData.length : length;
                    console.log('filteredData', filteredData, length);

                    for (i = 0; i < length; i++) {
                        if (filteredData[i].transactionType === 'S-Sale') {
                            filteredData[i].transactionType = 'Sale';
                        }
                        if (filteredData[i].transactionType === 'P-Purchase') {
                            filteredData[i].transactionType = 'Buy';
                        }
                        if (filteredData[i].typeOfOwner !== undefined && filteredData[i].typeOfOwner !== null) {
                            filteredData[i].typeOfOwner = filteredData[i].typeOfOwner.replace('officer: ', '');
                            filteredData[i].typeOfOwner = filteredData[i].typeOfOwner.replace('director, ', '');
                        }

                        newFilteredData.push(filteredData[i]);
                    }
                }
                this.setState({ list: newFilteredData });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    renderRow(listValue) {
        let resultColor = '';
        if (listValue.transactionType.toLowerCase().startsWith('sale')) {
            resultColor = 'red';
        } else if (listValue.transactionType.toLowerCase().startsWith('buy')) {
            resultColor = 'green';
        }
        
        return (
            <tr key={listValue.transactionDate + listValue.reportingName + listValue.price + listValue.securitiesTransacted}>
                <td style={{ color: resultColor}}>{listValue.transactionDate}</td>
                <td style={{ color: resultColor}}>{listValue.reportingName}</td>
                <MediaQuery minWidth={900}>
                    <td style={{ color: resultColor}}>{listValue.typeOfOwner}</td>
                </MediaQuery>
                <td style={{ color: resultColor}}>{listValue.transactionType}</td>
                <MediaQuery minWidth={900}>
                    <td style={{ color: resultColor}}>{listValue.price}</td>
                </MediaQuery>
                <td style={{ color: resultColor}}>{listValue.securitiesTransacted}</td>
                <MediaQuery minWidth={900}>
                    <td style={{ color: resultColor}}>{parseFloat(listValue.price * listValue.securitiesTransacted).toFixed(0)}</td>
                    <td style={{ color: resultColor}}>{parseFloat(listValue.securitiesOwned).toFixed(0)}</td>
                </MediaQuery>
            </tr>
        )
    }

    render() {
        let tableRow;
        if (this.state.list === undefined || this.state.list.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td><td></td><td></td><td></td><td></td><td></td><td></td></tr>
        } else {
            tableRow = this.state.list.map(this.renderRow.bind(this));
        }
        let header = 'Insider Trading';
        if (this.state.limit !== undefined) {
            header = <><Link to={'/insiderTrading/' + this.state.symbol}>{header}</Link> <Link style={{ fontSize: "10px"}} to={'/insiderTrading/' + this.state.symbol}>(More Details)</Link></>
        } else {
            header += ' - ' + this.state.symbol;
        }
        return (
            <div>
                {header}
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Name</th>
                            <MediaQuery minWidth={900}>
                                <th>Position</th>
                            </MediaQuery>
                            <th>Transaction</th>
                            <MediaQuery minWidth={900}>
                                <th>Price</th>
                            </MediaQuery>
                            <th>Shares#
                                &nbsp;&nbsp;
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="button-tooltip-2" style={{ wordBreak: 'break-all' }}>
                                        Insider trading involves trading in a public company's stock by someone who has non-public, material information about that stock for any reason. Insider trading can be either illegal or legal depending on when the insider makes the trade.<br /><br />
                                        This helps Investors or Traders to understand the activity of insiders and confidence level on the Company Stocks.                                        
                                    </Tooltip>}>
                                    <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                                </OverlayTrigger>
                            </th>
                            <MediaQuery minWidth={900}>
                                <th>Value</th>
                                <th>Total Sh#</th>
                            </MediaQuery>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default StockInsiderTrading;
